/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import _ from 'lodash';
import { IAny } from '../../components/DashboardKPIWidgets/IEnergyManagementProps';
import FileUploadAction from './FileUploadActions';
import { IFileUploadState } from './FileUploadContext';

interface IAction {
  type: string;
  payload?: IAny;
}
const fileUploadReducer = (state: IFileUploadState, action: IAction) => {
  switch (action.type) {
    case FileUploadAction.SHOW_MODAL:
      if (action.payload === false) {
        return {
          ...state,
          showModal: action.payload,
          acceptedFiles: [],
          acceptedCsvHeaders: []
        };
      }
      return {
        ...state,
        showModal: action.payload
      };
    case FileUploadAction.SHOW_PUBLISH_MODAL:
      if (action.payload === false) {
        return {
          ...state,
          showPublishModal: action.payload
        };
      }
      return {
        ...state,
        showPublishModal: action.payload
      };
    case FileUploadAction.SHOW_ZLO_MODAL:
      if (action.payload === false) {
        return {
          ...state,
          showZLOModal: action.payload,
          zloFile: null
        };
      }
      return {
        ...state,
        showZLOModal: action.payload
      };
    case FileUploadAction.SET_ZLO_FILE:
      return {
        ...state,
        zloFile: action.payload
      };
    case FileUploadAction.SET_ACCEPTED_FILES:
      return {
        ...state,
        acceptedFiles: action.payload
      };
    case FileUploadAction.SET_ACCEPTED_CSV_HEADERS:
      return {
        ...state,
        acceptedCsvHeaders: action.payload
      };
    case FileUploadAction.SHOW_ADD_FUEL_MODAL:
      return {
        ...state,
        showAddFuelModal: action.payload.boolVal,
        requestContext: action.payload.requestContext
      };
    case FileUploadAction.SET_MISSING_FUEL_MODAL:
      return {
        ...state,
        showAddFuelModal: true,
        selectedFuelMonthData: action.payload,
        modalType: 'missingData',
        isEditButtonEnabled: true
      };
    case FileUploadAction.HIDE_ADD_FUEL_MODAL:
      return {
        ...state,
        showAddFuelModal: false,
        selectedFuelMonthData: {},
        modalType: '',
        isEditButtonEnabled: true,
        requestContext: [],
        bearerToken: []
      };
    case FileUploadAction.SET_EDIT_FUEL_MODAL:
      return {
        ...state,
        showAddFuelModal: true,
        selectedFuelMonthData: action.payload,
        modalType: 'editFuelData',
        isEditButtonEnabled: true
      };
    case FileUploadAction.DISABLE_EDIT:
      return {
        ...state,
        isEditButtonEnabled: false
      };
    case FileUploadAction.SAVE_API_PAYLOAD:
      return {
        ...state,
        apiPayload: action.payload
      };
    default:
      return state;
  }
};

export default fileUploadReducer;
